import { useGetEmployeeMeQuery } from "../api/employee";
import { RoleEnum } from "../enums/RoleEnum";

export const useIsGroupManager = (): boolean => {
    const { data: getEmployeeMeData } = useGetEmployeeMeQuery({});

    return (
        (getEmployeeMeData?.roles?.filter(
            (role) => role.role === RoleEnum.ESTABLISHMENT_MANAGER,
        )?.length ?? 0) >= 2
    );
};
